import { categories } from "@/mocks/categories";

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl text-center mb-12 md:mb-16 leading-tight">
          Shop Smart with{" "}
          <span className="text-primary-500">acbuy spreadsheet</span>
        </h2>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          {/* Left large card */}
          <div className="lg:w-1/2">
            <a
              href={categories[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="block relative w-full h-[320px] md:h-[480px] rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Single%20premium%20white%20leather%20sneaker%20photographed%20from%20a%20low%20angle%20on%20a%20textured%20warm%20sand%20colored%20stone%20surface%2C%20dramatic%20golden%20hour%20side%20lighting%20casting%20long%20elegant%20shadows%2C%20minimalist%20product%20photography%20with%20architectural%20feel%2C%20clean%20modern%20composition%20with%20negative%20space%20on%20the%20right%20side%2C%20warm%20amber%20and%20ivory%20tones%20throughout&width=900&height=1100&seq=feature-shoes-v2&orientation=portrait"
                alt="Top Categories - Shoes"
                title="ACBuySpreadsheet Shoes Category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute bottom-5 left-5 px-4 py-2 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm font-semibold rounded-full whitespace-nowrap">
                Shoes
              </span>
            </a>
          </div>

          {/* Right stacked cards */}
          <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
            <a
              href={categories[1].url}
              target="_blank"
              rel="noopener nofollow"
              className="block relative w-full h-[150px] md:h-[230px] rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Oversized%20charcoal%20gray%20hoodie%20draped%20casually%20over%20a%20light%20oak%20wooden%20chair%20in%20a%20bright%20sunlit%20room%2C%20morning%20light%20streaming%20through%20sheer%20curtains%20creating%20soft%20dappled%20shadows%20on%20the%20fabric%2C%20lifestyle%20interior%20photography%20with%20warm%20cozy%20minimalist%20aesthetic%2C%20natural%20textures%20of%20wood%20grain%20and%20soft%20cotton&width=1000&height=600&seq=feature-hoodies-v2&orientation=landscape"
                alt="Hoodies and Sweaters"
                title="ACBuySpreadsheet Hoodies Category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <span className="absolute bottom-4 left-4 text-background-50 text-lg md:text-xl font-heading whitespace-nowrap">
                Hoodies / Sweaters
              </span>
            </a>
            <a
              href={categories[2].url}
              target="_blank"
              rel="noopener nofollow"
              className="block relative w-full h-[150px] md:h-[230px] rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Three%20crisp%20white%20cotton%20t-shirts%20hanging%20neatly%20on%20a%20minimalist%20wooden%20hanger%20rack%20against%20a%20light%20sage%20green%20painted%20wall%2C%20bright%20diffused%20studio%20lighting%20from%20above%20creating%20soft%20even%20illumination%2C%20clean%20Scandinavian%20interior%20photography%20with%20fresh%20serene%20atmosphere%2C%20subtle%20fabric%20texture%20visible%20on%20closest%20shirt&width=1000&height=600&seq=feature-tshirts-v2&orientation=landscape"
                alt="T-Shirts"
                title="ACBuySpreadsheet T-Shirts Category"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <span className="absolute bottom-4 left-4 text-background-50 text-lg md:text-xl font-heading whitespace-nowrap">
                T-Shirts
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}